import React from "react";
import { Container, Typography, Grid, Box } from "@mui/material";

function LogMode() {
    return (
        <Box sx={{ py: 2 }}>
            <Container maxWidth="lg">
                <Typography
                    align="center"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: "#030366",
                        mb: { xs: 2, sm: 5, md: 6 },
                        mt: 7,
                        fontSize: {
                            xs: "1.8rem", // mobile
                            sm: "2.2rem", // tablet
                            md: "2.8rem", // laptop
                            lg: "3rem",  // desktop
                        },
                    }}
                >
                    Log-Mode
                </Typography>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h5" sx={{ mb: 2, color: "#030366", fontWeight: "bold", }}>
                        Logistic Movement optimization Delivery Engagement (Log-MODE)
                    </Typography>

                    <Typography variant="body1" sx={{ mb: 2, textAlign: "justify" }}>
                        Log-MODE is a universal program designed to control all stages of delivery and field
                        services operations. The service allows to perform a wide range of tasks in logistics
                        and delivery – transportation arrangements, transport processes optimization and cost
                        saving.
                    </Typography>

                    <Typography variant="body1" sx={{ mb: 2, textAlign: "justify" }}>
                        Log-MODE comprises a web-version for dispatchers and a mobile application for drivers.
                        Web-version ensures effective operating procedures to create trips, order placement,
                        planning and distribution, Google Maps-based routing, delivery process monitoring and
                        coordination. Log-MODE mobile app is designed for drivers to easily manage delivery to
                        specified locations.
                    </Typography>

                    <Typography variant="body1" sx={{ mb: 2, textAlign: "justify" }}>
                        Log-MODE uses a big data platform to create delivery schedules dynamically, based on
                        urgency, low freight charges, return fleet, and driver/truck availability.
                    </Typography>

                    <Typography variant="body1" sx={{ mb: 2 }}>
                        Log-MODE has the following features:
                    </Typography>
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h5" sx={{ mb: 1, color: "#030366", fontWeight: "bold", }}>
                        Real-time tracking
                    </Typography>
                    <Typography variant="subtitle1" sx={{ color: "white" }}>
                        Driver can see his delivery location and route map in his mobile
                    </Typography>
                    <Typography variant="subtitle1" sx={{ mb: 2 }}>
                        Manager can see all movements in his Dashboard
                    </Typography>

                    <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item xs={12} md={6}>
                            <Box
                                component="img"
                                src="/images/scr1.png"
                                alt="Tracking screenshot"
                                sx={{ width: "100%", borderRadius: 2 }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="body1" sx={{ mb: 2 }}>
                                <b>Manager can change the schedule trips based on circumstances.</b>
                            </Typography>
                            <Box
                                component="img"
                                src="/images/scr2.png"
                                alt="Schedule screenshot"
                                sx={{ width: "100%", borderRadius: 2 }}
                            />
                        </Grid>
                    </Grid>

                    <Typography variant="h5" sx={{ mb: 1, color: "#030366", fontWeight: "bold", }}>
                        Request & Approvals
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        Approval process was implemented for the requests made by drivers like fuel, delivery
                        problems, vehicle problems.
                    </Typography>

                    <Box sx={{ maxWidth: 600, width: "100%" }}>
                        <Box
                            component="img"
                            src="/images/scr3.png"
                            alt="Request approval screenshot"
                            sx={{ width: "100%", borderRadius: 2 }}
                        />
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}

export default LogMode;
